export enum ImageDrawMode {
  ASPECT_FIT = "Aspect Fit",
  ASPECT_FILL = "Aspect Fill",
  SCAlE_TO_FILL = "Scale to Fill",
}

export default ImageDrawMode;
